import cn from 'classnames';
import styles from './styles.module.css';
import { Link, useNavigate } from 'react-router-dom';
import backSvg from '@/modules/common/icons/back.svg';
import { CSSProperties, ReactNode } from 'react';
import classNames from 'classnames';

export const PageTemplate = (props: IPageTemplateProps) => {
  const {
    className,
    mainClassName,
    children,
    header,
    back,
    customAction,
    customBack,
    customBackAction,
    ...rest
  } = props;
  const rootClass = cn(className, styles.root);
  const mainClass = cn(mainClassName, styles.main);
  const navigate = useNavigate();

  return (
    <div className={rootClass} {...rest}>
      {header && (
        <header className={styles.header}>
          <div className={styles.header__head}>
            {(customBack || customBackAction) && !back && (
              <img
                alt="back"
                src={backSvg}
                onClick={() =>
                  customBackAction
                    ? customBackAction()
                    : navigate(customBack || ('/mixing' as any))
                }
              />
            )}
            <h1 className={styles.title}>{header}</h1>
          </div>

          {!customAction ? (
            back && <Link to={back}>назад</Link>
          ) : (
            <a
              href="#"
              className={classNames(customAction.markered && styles.markered)}
              onClick={(e) => {
                e.preventDefault();
                customAction.action();
              }}
              style={customAction.style || {}}
            >
              {customAction.label}
            </a>
          )}
        </header>
      )}

      <main className={mainClass}>{children}</main>
    </div>
  );
};

export interface IPageTemplateProps
  extends React.HTMLAttributes<HTMLDivElement>,
    React.PropsWithChildren {
  header?: string;
  mainClassName?: string;
  back?: string;
  customAction?: {
    label: string | ReactNode;
    action: () => void;
    style?: CSSProperties;
    markered?: boolean;
  };
  customBack?: string | -1;
  customBackAction?: () => void;
}
